import React from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { handleSidebar } from 'apps/booking/utils/actions/sidebar'
import { shipmentListSelector } from 'apps/booking/utils/selectors/shipments'
import { sidebarStateSelector, activeRowIdSelector } from 'apps/booking/utils/selectors/sidebar'
import { uiSelector } from 'apps/booking/utils/selectors/ui'
import { SHIPMENT_TABS } from '../../constants/shipments'
import { BookingRow } from './BookingRow'

interface IBookingTableProps {
  shipmentCanBeSelected: (shipmentId: number, shipmentStatusKey: string) => void
  selectedShipments: number[]
  acceptedShipments: number[]
  rejectedShipments: number[]
  onAcceptShipmentClick: (shipmentId: number) => void
  onRejectShipmentClick: (shipmentId: number) => void
  onRowSelectionChange: (shipmentId: number, isSelected: boolean) => void
}

export const BookingTable = React.memo(
  ({
    acceptedShipments,
    onAcceptShipmentClick,
    onRejectShipmentClick,
    onRowSelectionChange,
    rejectedShipments,
    selectedShipments,
    shipmentCanBeSelected,
  }: IBookingTableProps) => {
    const { params, shipmentList: shipments } = useSelector(shipmentListSelector)
    const { selectedTabIndex } = useSelector(uiSelector)
    const { open: sidebarOpen } = useSelector(sidebarStateSelector)
    const { activeRowId } = useSelector(activeRowIdSelector)
    const dispatch = useDispatch()
    const openSidebar = (id: number, type = 'shipment') => dispatch(handleSidebar(id, type))

    const tab = SHIPMENT_TABS[selectedTabIndex]
    const { stateOptions } = params.filters
    const tabMatchesStateFilter = stateOptions ? tab.status.includes(stateOptions) : true

    if (!shipments.length || !tabMatchesStateFilter) {
      return (
        <div className='tc'>
          <hr className='ma0' />
          <h3>No shipments in the &ldquo;{tab.label}&rdquo; tab.</h3>
          <p className='text-secondary'>Try a different tab or a new search.</p>
        </div>
      )
    }

    const shipmentAcceptedSinceLastRefresh = (shipmentId: number) =>
      acceptedShipments.includes(shipmentId)
    const shipmentRejectedSinceLastRefresh = (shipmentId: number) =>
      rejectedShipments.includes(shipmentId)

    return (
      <>
        {shipments.map((shipment, i) => {
          const rowId = shipment.id === activeRowId ? undefined : shipment.id
          const activateRow = () => {
            if (rowId) {
              openSidebar(rowId)
            }
          }
          return (
            <BookingRow
              key={shipment.id}
              // @ts-ignore: TODO: Continue this refactor work!
              shipment={shipment}
              tabIndex={i}
              sidebarOpen={sidebarOpen}
              activateRow={activateRow}
              isActive={activeRowId === shipment.id}
              onCheckboxChange={onRowSelectionChange}
              checkboxEnabled={shipmentCanBeSelected(shipment.id, shipment.status.key)}
              rowIsChecked={selectedShipments.includes(shipment.id)}
              acceptedSinceLastRefresh={shipmentAcceptedSinceLastRefresh(shipment.id)}
              rejectedSinceLastRefresh={shipmentRejectedSinceLastRefresh(shipment.id)}
              onAcceptShipmentClick={onAcceptShipmentClick}
              onRejectShipmentClick={onRejectShipmentClick}
              currentTabName={tab.label}
            />
          )
        })}
      </>
    )
  }
)
